export const userRoles = {
    GUEST: 'ROLE_GUEST',
    USER: 'ROLE_USER',
    REPRESENTATIVE: 'ROLE_REPRESENTATIVE',
    REGIONAL_REPRESENTATIVE: 'ROLE_REGIONAL_REPRESENTATIVE',
    REGIONAL_ADMIN: 'ROLE_REGIONAL_ADMIN',
    TRAINER: 'ROLE_TRAINER',
    SECRETARY: 'ROLE_SECRETARY',
    MAIN_SECRETARY: 'ROLE_MAIN_SECRETARY',
    ADMIN: 'ROLE_ADMIN',
    SUPER_ADMIN: 'ROLE_SUPER_ADMIN',
};
